<!--
/**
* @name: Main.vue
* @description: 主框架模板
* @author: 温永江
* @create: 2020/07/22 15:47:03
* @update: 2020/07/22 15:47:03
*/
-->

<template>
  <transition name="y-fade">
    <div :class="css.v">
      <!-- 主菜单 -->
      <div :class="[css.aside, { [css.min_width]: !isSpread }]" @mouseenter="onOverNav" @mouseleave="onOutNav">
        <div :class="[css.logo, { [css.min_width]: !isSpread && !isOver }]">
          <img src="../assets/images/logo.png" style="height: 44px"/>
          <!-- <template v-if="!isDev">
            <img src="/img/logo_dock_short.png"
              v-if="!isSpread && !isOver" />
            <img src="/img/logo_dock.png"
              v-else /></template> -->
        </div>
        <k-scrollbar :class="[css.nav, { [css.min_width]: !isSpread && !isOver }]" ref="scrollbar">
          <div style="padding-bottom: 5px;">
            <ul :class="css.nav_list" v-for="item in menuList" :key="item.id">
              <li>
                <div :class="[
                    css.menu_name,
                    { [css.active]: currentMenu.id == item.id },
                    {
                      [css.fold_active]: currentMenu.id == item.id && !isOver && !isSpread
                    }
                  ]" @click="toggleMenu(item)">
                  <div>
                    <k-icon :class="[css.icon, { [css.icon_big]: !isSpread && !isOver }]" :name="item.icon" />
                    <span
                      :class="[css.first_menu, { [css.first_menu_hide]: !isSpread && !isOver }]">&#8194;{{ item.name }}</span>
                  </div>
                  <y-rotate-icon rotate size="12" v-show="isSpread || isOver"
                    :deg="currentMenu.id == item.id && showList ? '90' : '0'" />
                </div>
                <k-transition @after-transition="$refs.scrollbar.reset">
                  <ul v-show="(isSpread || isOver) && currentMenu.id == item.id && showList" :class="css.sub_nav_list">
                    <li v-for="item1 in item.children" :key="item1.id">
                      <!-- 只有二级菜单的情况 -->
                      <template v-if="item1.children == null || item1.children.length === 0">
                        <div href="javascript:;" :class="[
                            css.sub_menu_name,
                            { [css.active]: lastMenuIds[lastMenuIds.length - 1] == item1.id && currentSubMenu.id != 'HOME' }
                          ]" @click="onGoto(item1)">
                          {{ item1.name }}
                        </div>
                      </template>
                      <!-- 二级菜单下有三级菜单时 -->
                      <template v-else>
                        <div href="javascript:;"
                          :class="[css.sub_menu_name, css.has_3, { [css.active]: current3Menu.id == item1.id }]"
                          @click.stop="toggleSubMenu(item1)">
                          <div>{{ item1.name }}</div>
                          <y-rotate-icon rotate size="12" v-show="isSpread || isOver"
                            :deg="currentSubMenu.id == item1.id && show3List ? '90' : '0'" />
                        </div>
                      </template>
                      <k-transition v-if="item1.children && item1.children.length"
                        @after-transition="$refs.scrollbar.reset">
                        <ul :class="css.sub_3_list" v-show="show3List && currentSpreadSubId == item1.id">
                          <li v-for="item2 in item1.children" :key="item2.id" @click.stop="onGoto3(item2)">
                            <div
                              :class="[css.sub_3_name, { [css.active]: lastMenuIds && lastMenuIds[lastMenuIds.length - 1] == item2.id }]">
                              {{ item2.name }}
                            </div>
                          </li>
                        </ul>
                      </k-transition>
                    </li>
                  </ul>
                </k-transition>
              </li>
            </ul>
          </div>
        </k-scrollbar>
      </div>
      <div :class="[css.main, { [css.min_ml]: !isSpread }]">
        <!-- 顶部菜单和个人信息 -->
        <div :class="css.top">
          <!-- 顶部个人信息 -->
          <user-info :class="css.user_info" @getShow="getUserInfoShow" />
          <!-- 顶部快捷菜单 -->
          <div :class="css.tab">
            <div :class="css.tab_list">
              <div @click="toggleSpread" :class="[css.tab_item, css.tab_item_icon]">
                <k-icon :name="!isSpread ? 'icon-spread' : 'icon-fold'" />&nbsp;
              </div>
              <div :class="[
                  css.tab_item,
                  {
                    [css.active]: currentSubMenu.id == 'HOME' || quickMenu.length === 0
                  }
                ]" @click="goHome">
                <k-icon name="icon-home" size="14" />&#8194;首页&#8194;
              </div>
              <div :class="[
                  css.tab_item,
                  css.tab_item_equal,
                  { [css.active]: lastMenuIds && lastMenuIds.length && lastMenuIds[lastMenuIds.length - 1] == item.id && currentSubMenu.id != 'HOME' }
                ]" v-for="item in quickMenu" :key="item.id" @click="onToggleTab(item)"
                @contextmenu="onContext(item, $event)">
                <span>{{ item.name }} </span>
                <k-icon :class="css.close" name="k-icon-close" @click="toClose(item, $event)" />
                <div :class="css.jiao"></div>
              </div>
              <More v-if="quickMenu && quickMenu.length >= 8" v-model="showMore" :class="css.more" :data="quickMenu"
                @go="onGoto($event, null)" @close="toClose($event, null)" @close-by-ctx="onCloseByCtx" />
            </div>
          </div>
        </div>
        <!-- iframe -->
        <div v-show="quickMenu.length > 0 && currentSubMenu.id !== 'HOME'"
          :class="[css.iframe_list, { [css.show]: showMask }]" ref="iframeList">
          <template v-for="item in quickMenu">
            <iframe :key="item.id" tabindex="-1" :id="'_' + item.id"
              v-show="lastMenuIds[lastMenuIds.length - 1] == item.id"></iframe>
          </template>
        </div>
        <Home v-show="quickMenu.length === 0 || currentSubMenu.id === 'HOME'" />
      </div>
      <Ctx :top="ctx.top" :left="ctx.left" v-model="ctx.show" @close="onCloseByCtx" />
    </div>
  </transition>
</template>
<script>
  /**
   * 此组件是一个控制中心
   * 其中包括：
   *  1. 主菜单
   *  2. 快捷页签菜单
   *  3. 接收从iframe内部发出的通知：告诉window.top打开或者关闭一个页签
   *  4. 接收从iframe内部发出的重新登录通知
   */
  import UserInfo from './components/UserInfo';
  import Ctx from './components/ContextMenu';
  import More from './components/MoreTabItem';
  import Home from './Home';

  import { XTL_USER_SERVER_MENU_LIST } from '@/assets/modules/apiList';

  export default {
    components: {
      More,
      Home,
      UserInfo,
      Ctx
    },
    data() {
      return {
        isOver: false,
        isSpread: true,
        showMore: false,
        ctx: {
          show: false,
          top: '-9999',
          left: '-9999'
        },
        showList: false,
        show3List: false,
        showMask: false,
        // 菜单列表
        menuList: [],
        // 顶部页签（快捷菜单）
        quickMenu: [],
        currentSpreadSubId: -1, // 记录展开的二级菜单
        currentSubMenu: {}, // 当前二级菜单
        current3Menu: {},
        currentMenu: {}, // 当前大菜单
        lastMenuIds: [], // 最近点击的菜单Id列表
        currentCtxMenu: {}, // 右键点击时的当前菜单
        // 为了防止浏览器缓存造成的无法及时更新问题
        // 故设置一个标示，此标示在页面刷新后会重新创建，
        // 也就是说页面刷新后组件重新创建了，所以这个标示
        // 也重新创建了，然后将此标示写入url中，强制页面刷新
        // 为什么这样设置：
        // 防止页面中query数据变化时造成的页面刷新
        // 只有当用户刷新顶部窗口时，才会更新此标示
        // 同时也避免了浏览器缓存问题
        // 这么做既避免了浏览器缓存，又充分利用了浏览器资源
        pageRefreshFlag: ''
      };
    },
    computed: {
      isDev() {
        return process.env.NODE_ENV == 'development';
      }
    },
    watch: {
      'currentSubMenu.id': {
        immediate: true,
        handler(id) {
          this.setSrc(id, 'currentSubMenu');
        }
      },
      'current3Menu.id': {
        immediate: true,
        handler(id) {
          console.log(id);
          this.setSrc(id, 'current3Menu');
        }
      },
      'ctx.show'(v) {
        this.showMask = v;
      },
      showMore(v) {
        this.showMask = v;
      }
    },
    methods: {
      setSrc(id, prop) {
        this.$nextTick().then(() => {
          if (id) {
            const ref = this.$refs.iframeList.querySelector(`#_${id}`);
            if (ref) {
              const newSrc = this.iframeSrc(this[prop]);
              if (ref.src) {
                if (newSrc != ref.src) {
                  ref.src = newSrc;
                }
              } else {
                ref.src = newSrc;
              }
            }
          }
        });
      },
      iframeSrc(item) {
        // const urlHasFlag = item.url.replace('#', `?t=${this.pageRefreshFlag}#`);
        const urlHasFlag = `?t=${this.pageRefreshFlag}#${item.url}`;
        let url = `${window.location.origin}/${urlHasFlag}`;
        if (item.params) {
          for (let p in item.params) {
            url += `/${item.params[p]}`;
          }
        }
        if (item.query) {
          let arr = [];
          for (let q in item.query) {
            arr.push(`${q}=${item.query[q]}`);
          }
          url += `?${arr.join('&')}`;
        }
        return url;
      },
      onOverNav() {
        if (!this.isSpread) {
          this.isOver = true;
        }
      },
      onOutNav() {
        if (!this.isSpread) {
          setTimeout(() => {
            this.isOver = false;
          }, 50);
        }
      },
      toggleSpread() {
        this.isSpread = !this.isSpread;
        this.$lf.setItem('menu_is_spread', this.isSpread);
      },
      onContext(item, e) {
        this.ctx.top = e.clientY;
        this.ctx.left = e.clientX;
        this.ctx.show = true;
        this.currentCtxMenu = item;
        e.preventDefault();
      },
      goHome() {
        this.currentSubMenu = { id: 'HOME' };
        this.$lf.setItem('currentSubMenu', { id: 'HOME', name: '首页' });
        // this.$lf.setItem('lastMenuIds', [...new Set([...this.lastMenuIds, 'HOME'])]);
        window.top.document.title = '首页';
      },
      getUserInfoShow(v) {
        this.showMask = v;
      },
      onCloseByCtx(i, ctxMenu) {
        if (ctxMenu) {
          this.currentCtxMenu = ctxMenu;
        }
        // 0关闭，1关闭其他，2关闭所有
        if (i == 0) {
          this.toClose(this.currentCtxMenu);
        } else {
          if (i == 1) {
            this.currentSubMenu = this.currentCtxMenu;
            this.quickMenu = [this.currentCtxMenu];
            this.lastMenuIds = [this.currentCtxMenu.Id];
          } else if (i == 2) {
            this.quickMenu = [];
            this.currentSubMenu = {};
            this.lastMenuIds = [];
            this.currentMenu = {};
            this.$lf.setItem('currentMenu', {});
            this.showMask = false;
            this.goHome();
          }
          if (i != 2) {
            this.$lf.setItem('currentSubMenu', this.currentSubMenu);
          }
          this.$lf.setItem('quickMenu', this.quickMenu);
          this.$lf.setItem('lastMenuIds', this.lastMenuIds);
        }
      },
      toClose(item, e) {
        if (item.id == this.current3Menu.id) {
          this.current3Menu = {}
          this.$lf.setItem('current3Menu', {})
        }
        let i = -1;
        this.quickMenu.forEach((q, idx) => {
          if (item.id === q.id) {
            i = idx;
          }
        });
        if (i > -1) {
          this.quickMenu.splice(i, 1);
          this.setLast(item.id, true);
          if (item.id == this.currentSubMenu.id) {
            if (this.lastMenuIds.length) {
              const lastId = this.lastMenuIds.slice(-1)[0];
              this.currentSubMenu = this.quickMenu.filter(q => q.id == lastId)[0] || {};
            } else {
              this.currentSubMenu = {};
            }
          }
          if ('id' in this.currentSubMenu) {
            this.$lf.setItem('currentSubMenu', this.currentSubMenu);
          } else {
            this.goHome();
          }
          this.$lf.setItem('quickMenu', this.quickMenu);
        }
        if (this.quickMenu.length <= 14) {
          this.showMask = false;
        }
        e && e.stopPropagation();
      },
      // 大菜单展开、折叠、切换
      toggleMenu(item) {
        const { currentMenu } = this;
        if (currentMenu.id == item.id) {
          this.showList = !this.showList;
        } else {
          this.showList = true;
          this.currentMenu = item;
          this.$lf.setItem('currentMenu', item);
        }
      },
      toggleSubMenu(item) {
        if (item.id != this.currentSpreadSubId) {
          this.show3List = true;
        } else {
          this.show3List = !this.show3List;
        }
        if (this.show3List) {
          this.currentSpreadSubId = item.id;
        } else {
          this.currentSpreadSubId = -1;
        }
        this.$lf.setItem('currentSpreadSubId', this.currentSpreadSubId);
        // const { currentSubMenu } = this;
        // if (currentSubMenu.id == item.id) {
        //   this.show3List = !this.show3List;
        // } else {
        //   this.show3List = true;
        //   this.currentSubMenu = item;
        //   this.$lf.setItem('currentSubMenu', item);
        // }
      },
      setLast(id, isDelete) {
        let arr = [...this.lastMenuIds].filter(_id => !!_id);
        const i = arr.findIndex(n => n == id);
        if (i === -1) {
          arr.push(id);
        } else if (isDelete) {
          // console.log(arr)
          arr.splice(i, 1);
        } else {
          arr.push(...arr.splice(i, 1));
        }
        arr = arr.filter(a => a !== undefined);
        this.lastMenuIds = arr;
        this.$lf.setItem('lastMenuIds', arr);
      },
      onToggleTab(item) {
        const { code } = item;
        if (!code) {
          this.onGoto(item);
        } else if (code.length == 4) {
          this.onGoto(item);
          this.showList = true;
          const pcode = item.pcode;
          this.menuList.forEach(el => {
            if (el.code == pcode) {
              this.currentMenu = el;
              this.$lf.setItem('currentMenu', el);
            }
          });
        } else if (code.length == 6) {
          this.onGoto3(item);
          this.showList = true;
          this.show3List = true;
        }
      },
      // 页面切换
      onGoto(item1) {
        let { closeRoute, ...item } = item1;
        let i = -1;
        let iClose = -1;
        this.quickMenu.forEach((m, idx) => {
          if (m.id == item1.id) {
            i = idx;
          }
          if (item1.closeRoute && item1.closeRoute.id == m.id) {
            iClose = idx;
          }
        });
        if (i > -1) {
          this.quickMenu.splice(i, 1, { ...item });
        } else {
          this.quickMenu.push({ ...item });
        }
        // 如果有需要删除的页签
        if (iClose > -1) {
          this.quickMenu.splice(iClose, 1);
        }
        this.currentSubMenu = item || {};
        this.setLast(item1.id);
        this.$lf.setItem('quickMenu', this.quickMenu);
        this.$lf.setItem('currentSubMenu', item);
        this.show3List = false;
        window.top.document.title = item.title || `${item.name}`;
      },
      onGoto3(item2) {
        let i = -1;
        this.quickMenu.forEach((m, idx) => {
          if (m.id == item2.id) {
            i = idx;
          }
        });
        if (i > -1) {
          this.quickMenu.splice(i, 1, { ...item2 });
        } else {
          this.quickMenu.push({ ...item2 });
        }
        this.setLast(item2.id);
        this.$lf.setItem('quickMenu', this.quickMenu);
        this.$lf.setItem('currentSubMenu', {});
        this.$lf.setItem('current3Menu', item2);
        this.current3Menu = item2;
        this.currentSubMenu = {};
        window.top.document.title = item2.title || `${item2.name}`;
        const pid = item2.pid;
        let id = -1;
        this.menuList.forEach(item => {
          if (item.children && item.children.length) {
            item.children.forEach(el => {
              if (el.id == pid) {
                id = el.id;
                this.currentMenu = item;
                this.$lf.setItem('currentMenu', item);
              }
            });
          }
        });
        if (id !== -1) {
          this.currentSpreadSubId = id;
          this.$lf.setItem('currentSpreadSubId', id);
        }
      },
      getMenuList() {
        // return this.$fetch({
        //   api: XTL_USER_SERVER_MENU_LIST
        // }).then(data => {
        //   this.$lf.setItem('menuList', data);
        //   this.menuList = data;
        //   return data;
        // });
        return this.$lf.getItem('login').then(loginInfo => {
          // 菜单过滤放到此处，用于按钮权限判断的数据仍然可以读取loginInfo的内容，不用再单独请求接口
          const filterMenu = menu => {
            menu.forEach(m => {
              if (m.type == 'MENU') {
                if (m.children && m.children.length) {
                  m.children = m.children.filter(f => {
                    if (f.type == 'MENU') {
                      if (f.children && f.children.length) {
                        if (f.children) {
                          f.children.forEach((d, i) => {
                            if (d.type == 'BUTTON') {
                              f.children.splice(i, 1);
                            }
                          });
                        }
                        filterMenu(f.children);
                      }
                    }
                    return f.type == 'MENU';
                  });
                }
              }
            });
          };
          if (loginInfo) {
            if (loginInfo.menuTreeList && Object.prototype.toString.call(loginInfo.menuTreeList) == '[object Array]') {
              filterMenu(loginInfo.menuTreeList);
            }
            let menus = loginInfo.menuTreeList;
            this.$lf.setItem('menuList', menus);
            this.menuList = menus;
          }
          return loginInfo;
        });
      },
      getQuickMenu() {
        return this.$lf.getItem('quickMenu').then(data => {
          if (data) {
            this.quickMenu = data;
          }

          return data;
        });
      },
      async getCurrentMenu() {
        await this.$lf.getItem('currentMenu').then(data => {
          if (data) {
            this.currentMenu = data;
            this.showList = true;
          }
        });
        const submenu = await this.$lf.getItem('currentSubMenu').then(data => {
          if (data) {
            this.currentSubMenu = data;
          }
          return data;
        });
        await this.$lf.getItem('current3Menu').then(data => {
          if (data) {
            this.current3Menu = data;
          }
        });
        // console.log(submenu);
        return this.current3Menu;
      },
      getLastIds() {
        return this.$lf.getItem('lastMenuIds').then(data => {
          if (data) {
            this.lastMenuIds = data;
          }
          return data;
        });
      },
      getSpreadSubId() {
        return this.$lf.getItem('currentSpreadSubId').then(data => {
          if (data) {
            this.currentSpreadSubId = data;
          }
          return data;
        });
      },
      handleOpenTab(e) {
        if (e.detail.id !== undefined) {
          this.onGoto(e.detail);
          // console.log(e);
        }
        e.stopImmediatePropagation();
      },
      handleCloseTab(e) {
        this.toClose(e.detail, null);
        e.stopImmediatePropagation();
      },
      async handleLogin() {
        const keep = await this.$lf.getItem('keepQuickMenu');
        if (keep && keep == 1) {
          this.$router.replace({ name: 'login', query: { keep: 1 } });
        } else {
          this.$router.replace({ name: 'login' });
        }
      },
      async getSpread() {
        const s = await this.$lf.getItem('menu_is_spread');
        if (typeof s === 'boolean') {
          this.isSpread = s;
        } else {
          this.isSpread = true;
        }
      }
    },
    created() {
      this.pageRefreshFlag = new Date() - 0;
      // window.top打开一个页签
      window.addEventListener('opentab', this.handleOpenTab);
      // window.top关闭一个页签
      window.addEventListener('closetab', this.handleCloseTab);
      // token失效或者无token时跳转到登录页
      window.addEventListener('login', this.handleLogin);
      // 获取菜单的展开状态
      this.getSpread();
      this.getMenuList().then(() => {
        Promise.all([this.getSpreadSubId(), this.getQuickMenu(), this.getCurrentMenu(), this.getLastIds()]).then(() => {
          if ('id' in this.current3Menu && this.lastMenuIds.length) {
            if (this.current3Menu.id == this.lastMenuIds.slice(-1)[0]) {
              this.show3List = true;
            }
          }
        });
      });
    },
    beforeDestroy() {
      window.removeEventListener('opentab', this.handleOpenTab);
      window.removeEventListener('closetab', this.handleCloseTab);
      window.removeEventListener('login', this.handleLogin);
    }
  };
</script>
<style lang="postcss" module="css">
  .v {
    letter-spacing: 1px;

    & .logo {
      height: var(--top-height);
      width: var(--menu-width);
      background-image: linear-gradient(90deg, #252e42, #252e42);
      line-height: var(--top-height);
      text-align: center;
      color: white;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 2;
      transition: width var(--transition);

      & img {
        vertical-align: middle;
      }
    }

    min-width: 1080px;
    height: 100%;
    background-color: white;

    & .aside {
      width: var(--menu-width);
      height: 100%;
      transition: width var(--transition);
      float: left;

      & .menu_name {
        color: var(--menu-text-color);
        height: var(--menu-item-height);
        line-height: var(--menu-item-height);
        font-size: 14px;
        padding: 0 17px 0 23px;
        cursor: pointer;
        background-color: var(--menu-background-color);
        display: flex;
        justify-content: space-between;
        transition: var(--transition);

        &:hover {
          color: var(--menu-active-text-color);
        }

        &.active {
          color: var(--menu-active-text-color);
        }

        &.fold_active {
          color: var(--color-primary);
          position: relative;

          &:after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 5px;
            right: 5px;
            background-color: var(--menu-active-background-color);
          }
        }

        & .first_menu {
          transition: transform var(--transition);
          display: inline-block;
          font-weight: 600;

          &.first_menu_hide {
            transform: scale(0, 0);
            width: 0;
            height: 0;
            overflow: hidden;
          }
        }
      }

      &>.nav {
        background-color: var(--menu-background-color);
        width: var(--menu-width);
        top: var(--top-height);
        bottom: 0;
        left: 0;
        position: fixed;
        overflow: hidden;
        z-index: 1;
        transition: width var(--transition);

        & .pname {
          color: white;
          opacity: 0.2;
          padding: 18px 12px 0 23px;
          user-select: none;
          transition: opacity var(--transition);
          white-space: nowrap;

          &.pname_hide {
            opacity: 0;
          }
        }

        & ul.nav_list {
          background-color: var(--menu-background-color);
        }

        & ul.sub_nav_list {
          background-color: var(--menu-active-background-color);

          &>li {
            &>.sub_menu_name {
              color: var(--menu-text-color);
              font-size: 14px;
              font-weight: 600;
              padding: 0 14px 0 45px;
              height: 45px;
              line-height: 45px;
              text-decoration: none;
              transition: var(--transition);
              position: relative;
              z-index: 0;
              cursor: pointer;

              &.has_3 {
                display: flex;
                justify-content: space-between;
                align-items: center;
              }

              &.active {
                color: var(--sub-menu-active-text-color);
              }
            }

            &:hover {
              background-color: var(--sub-menu-active-background-color);

              &>.sub_menu_name:not(.active) {
                color: white;
              }
            }

            &>.sub_3_list {
              &>li {
                &>.sub_3_name {
                  color: var(--menu-text-color);
                  font-size: 14px;
                  font-weight: 600;
                  padding: 0 14px 0 60px;
                  height: 45px;
                  line-height: 45px;
                  display: block;
                  text-decoration: none;
                  transition: var(--transition);
                  position: relative;
                  z-index: 0;
                  cursor: pointer;

                  &.active {
                    color: var(--sub-menu-active-text-color);
                  }
                }
              }
            }
          }
        }
      }
    }

    & .main {
      margin-left: var(--menu-width);
      height: 100%;
      transition: margin-left var(--transition);

      & .top {
        background-color: var(--top-background-color);
        border-bottom: 1px solid #eee;
        height: var(--top-height);
      }

      & .user_info {
        float: right;
      }

      & .tab {
        margin-right: 150px;
        height: var(--top-height);
        overflow: hidden;
        user-select: none;
        padding-top: 6px;
      }

      & .tab_list {
        height: calc(var(--top-height) - 6px);
        line-height: calc(var(--top-height) - 6px);
        overflow: hidden;
        display: inline-block;
        position: relative;
        padding-right: 35px;

        & .tab_item {
          position: relative;
          float: left;
          height: 100%;
          padding: 0 5px 0 12px;
          color: var(--color-font-3);
          cursor: pointer;
          transition: var(--transition);
          /* display: flex;
        align-items: center; */
          border-top-left-radius: calc(var(--radius) * 2);
          border-top-right-radius: calc(var(--radius) * 2);

          &>span:first-child {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
          }

          &:after {
            content: '';
            position: absolute;
            bottom: 13px;
            border-right: 1px solid #bfbfbf;
            right: -1px;
            height: 13px;
          }

          & .close {
            width: 16px;
            height: 16px;
            text-align: center;
            margin-left: 2px;
            color: var(--color-font-3);
            font-size: 12px;
            transition: var(--transition);
            border-radius: 100%;
            line-height: 1.1;
            visibility: hidden;
            font-weight: normal;
            position: absolute;
            padding: 1px 0 0 2px;
            right: 8px;
            top: 11px;
            z-index: 2;
          }

          /* & .jiao {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 100%;
          background-color: red;
          bottom: 0;
          left: -16px;
        } */
          &:hover {
            background-color: #f5f5f5;
            z-index: 3;

            & .close {
              visibility: visible;

              &:hover {
                color: var(--color-font-2);
                background-color: #ddd;
                box-shadow: -15px 0 10px #eee;
              }
            }
          }

          &.active {
            background-color: white;
            color: var(--color-primary);
            font-weight: bold;

            &:after {
              visibility: hidden;
            }

            & .close {
              visibility: visible;
            }

            &:hover {
              & .close {
                color: var(--color-primary);
                box-shadow: none;
              }
            }
          }

          &.tab_item_icon {
            &:hover {
              background-color: var(--color-bg);
            }
          }

          &.tab_item_equal {
            min-width: 107px;
            padding-right: 20px;
          }
        }

        &:after,
        &:before {
          content: '';
          clear: both;
          height: 0;
        }
      }

      & .iframe_list {
        background-color: white;
        height: calc(100% - var(--top-height));
        position: relative;
        transition: 0.5s;

        &:after {
          /* content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: none;
        transition: 0.5s;
        background-color: rgba(0, 0, 0, 0.01); */
        }

        &.show {
          &:after {
            display: block;
          }

          & iframe {
            /* filter: blur(1px); */
          }
        }

        & iframe {
          display: block;
          border: none;
          width: 100%;
          height: 100%;
          transition: filter 0.5s;
        }
      }
    }

    & .icon {
      font-size: 16px;
      transition: var(--transition);
      display: inline-block;
      position: relative;
      z-index: 2;

      &.icon_big {
        /* transform: scale(1.2,1.2); */
      }
    }

    & .more {
      width: 25px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .min_width {
    width: var(--menu-min-width) !important;
  }

  .min_ml {
    margin-left: var(--menu-min-width) !important;
  }
</style>